import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const layoutScroll=document.getElementsByClassName('layout_scroll')[0];
    layoutScroll.scrollTop=0;

  }, [pathname]);

  return null;
}
